<template>
    <BasePanel 
        headline="lang_GENERAL_CAPTION_PDF"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-container fluid>
                <v-row justify="center">
                    <v-col
                        cols="10"
                        v-if="pdfPath !== null"
                    >
                        <iframe
                            v-if="pdfBlobUrl"
                            :src="pdfBlobUrl"
                            frameborder="0"
                            width="90%"
                            height="800px"
                        ></iframe>
                        <div
                            v-else-if="loadError"
                            class="v-data-table__empty-wrapper"
                            :alvqa="alvqa + '-load-error-text'"
                        >
                            {{ $t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE') }}
                        </div>
                        <div
                            v-else
                            class="d-flex justify-center pa-4"
                        >
                            <v-progress-circular
                                indeterminate
                                color="primary"
                            ></v-progress-circular>
                        </div>
                    </v-col>
                    <v-col 
                        cols="1"
                        v-if="pdfPath !== null"
                    >
                        <BaseIcon 
                            @click="deletePdf"
                            icon="delete"
                            color="iconDelete"
                            tooltipText="lang_GENERIC_CAPTION_DELETE"
                            :alvqa="alvqa + '-icon-delete'"
                        />
                    </v-col>
                    <v-col 
                        cols="3"
                        v-else
                    >
                        <BaseButton 
                            class="text-center"
                            :disabled="$route.params.alvId === 'new'"
                            label="lang_GENERAL_BUTTON_UPLOAD_PDF"
                            @click="openUploadialog"
                            :alvqa="alvqa + '-button-upload-pdf'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BasePanel>
</template>

<script>
import api from '@/api_alv'
import BasePanel from '@/components/_base/BasePanel'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "PdfSheetPanel",
    components: {
        BasePanel,
        BaseButton,
        BaseIcon
    },
    data() {
        return {
            alvqa: 'publishing-sheets-edit-form-panel-pdf',
            pdfBlobUrl: null,
            loadError: false
        }
    },
    computed: {
        pdfPath() { return this.$store.getters.getSheetsPdfPath }
    },
    watch: {
        // Reload the preview whenever the PDF is (re)uploaded, deleted, or the
        // edited sheet changes.
        pdfPath: {
            immediate: true,
            handler() {
                this.loadPdf()
            }
        }
    },
    beforeDestroy() {
        this.revokeBlobUrl()
    },
    methods: {
        // The BE returns the PDF behind a secure URL served with
        // `Content-Disposition: attachment`, which makes the browser download
        // the file instead of previewing it — even inside an <iframe>. We fetch
        // the bytes ourselves and render them through a blob: object URL, which
        // the disposition header does not apply to, so the PDF shows inline.
        async loadPdf() {
            this.revokeBlobUrl()
            this.loadError = false

            if (!this.pdfPath) {
                return
            }

            try {
                const blob = await api.getFileBlobFromALV(this.pdfPath)
                // Force the type so the browser opens its native PDF viewer even
                // if the response Content-Type is generic (e.g. octet-stream).
                const pdfBlob = blob.type === 'application/pdf'
                    ? blob
                    : new Blob([blob], { type: 'application/pdf' })
                this.pdfBlobUrl = window.URL.createObjectURL(pdfBlob)
            } catch (error) {
                this.loadError = true
            }
        },
        revokeBlobUrl() {
            if (this.pdfBlobUrl) {
                window.URL.revokeObjectURL(this.pdfBlobUrl)
                this.pdfBlobUrl = null
            }
        },
        openUploadialog() {
            let dialogText = this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') + ' ' + this.$t('lang_PUBLISHING_SHEETS_DIALOG_SHEET_FILE') + '. <br />' + 
                             this.$t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE').replace("<join>", "PDF/ZIP")  

            this.$store.commit('setUploadPDFDialogText', dialogText)
            this.$store.commit('setShowUploadPDFDialog', true)
        },
        deletePdf() {
            this.$store.commit('setDeletionDialogContext', 'SheetPdf')
            this.$store.commit('setShowDeletionDialog', true)
        },
    }
}
</script>